import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'shipping_1'

export const dataPointDefinition = {
  retracedId: 'shipping_1',
  name: 'Shipping',
  description: '',
  meta: {
    slcpMeta: {
      key: 'fp-pi-8-8',
      number: 'FP-PRO-9-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-11',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1],fp-pi-2-6',
      machineShowHide: '[1],fp-pi-2-6',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pi-8-8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28630,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
